<template>
  <div class="page page-collection">
    <div
      class="page__wrap"
      data-animate="page-wrap"
      :class="{
        'p-bot-3': count > limit,
      }"
    >
      <div class="row-1 page-collection-header p-top-3">
        <header>
          <!-- Title -->
          <div class="row-1">
            <h1 data-animate="header-title" class="title-m">
              {{ $t('listing.collections') }}
            </h1>
          </div>
        </header>

        <ListingFilters
          :families="familiesForFilters"
          @selected="onFilterSelected"
        />
      </div>
      <ListingList
        class="row-1 m-top-3 page-collection-list"
        :class="{
          'p-bot-3': count <= limit,
        }"
        :items="formattedFamily"
      />
      <WidgetPaginationListing
        class="row-1 flex --justify-center m-top-5"
        v-if="count > limit"
        :itemPerPage="limit"
        :total="count"
      />
    </div>
  </div>
</template>

<script setup>
import { isInSeries } from '~/assets/js/junk.js'

import { useCraftStore } from '@/store/craft.js'

// Importa le query GraphQL
import queries from '@/graphql/craft/queries/index.js'

import {
  onBeforeEnter,
  onEnter,
  onLeave,
} from '~/assets/js/page-transitions/listing.js'

definePageMeta({
  layout: 'default',
  pageTransition: {
    onBeforeEnter: (el) => {
      onBeforeEnter(el)
    },
    onEnter: async (el, done) => {
      const tl = onEnter(el, done)
      await tl.delay(0.75).play()
      done()
    },

    onLeave: async (el, done) => {
      const tl = onLeave(el)
      await tl.play()
      window.lenis.scrollTo(0, { immediate: true })
      done()
    },
  },
})

// Ottieni la configurazione dal tuo store personalizzato
const { configuration } = useCraftStore()
const route = useRoute()

// Inizializza le variabili reattive che conterranno le famiglie e le categorie di prodotti
const selectedCategories = ref(route.query?.categories || [])

// Fetch Data
const queryIds = queries.typologies.getTypologyIds
const queryFamilies = queries.typologies.getTypology
const key = 'collezione'
const keyId = 160
const type = 'family'

const limit = ref(25)

const variables = computed(() => ({
  site: configuration.site,
  marketId: configuration.marketId,
  typologyId: keyId,
  type,
  limit: limit.value,
  offset: route.query?.page
    ? (parseInt(route.query?.page) - 1) * limit.value
    : 0,
  categoryId: selectedCategories.value.length
    ? selectedCategories.value
    : route.query?.categories,
  // lineId: configuration.lineId('decorative'),
}))

// Ottengo gli id dei prodotti che hanno figli per poi chiamarli
const { data: familyFilteresIds } = await useGraphql(queryIds, {
  ...variables.value,
  limit: null,
})

const familiesIds = ref(
  familyFilteresIds.value?.productsEntries
    .filter((family) => family.children.length > 0)
    .map((family) => family.id) || []
)

// In base agli id caricati al primo load ottengo i dati dei prodotti
// Se non ho filtri selezionati gli id non devono essere passati quindi passo NULL
const { data } = await useGraphql(queryFamilies, {
  ...variables.value,
  typologyKey: key,
  id: selectedCategories.value.length ? familiesIds.value : null,
})
const families = ref(data.value?.productsEntries || [])
const count = ref(data.value?.entryCount || 0)

watchEffect(async () => {
  // TODO: Questo è una schifezza da rivedere con dei watcher nei progetti futuri

  // Quando attivo un filtro gli id cambiano e quindi richiamo i prodotti
  // Se non ho filtri selezionati gli id non devono essere passati quindi passo NULL
  const { data: familyFilteresIds } = await useGraphql(queryIds, {
    ...variables.value,
    limit: null,
  })

  familiesIds.value =
    familyFilteresIds.value?.productsEntries
      .filter((family) => family.children.length > 0)
      .map((family) => family.id) || []

  const { data } = await useGraphql(queryFamilies, {
    ...variables.value,
    typologyKey: key,
    id: selectedCategories.value.length ? familiesIds.value : null,
  })
  families.value = data.value?.productsEntries || []
  count.value = data.value?.entryCount || 0
})

// Le famiglie dei filtri sono unref perché i filtri non devono mutare. Se aggiornassi ogni volta i filtri cambierebbero in base ai prodotti filtrati.
const { data: filters } = await useGraphql(queries.categories.getCategories, {
  site: configuration.site,
})
const familiesForFilters = filters.value?.categoriesEntries

const seo = computed(() => data.value?.entry?.seo || {})

const formattedFamily = computed(() => {
  // TODO: Rimuovi e lascia  families.value.map(....)
  return [...families.value].map((family, index, array) => {
    // LargeItem mi indica se nel listing il prodotto occupa più spazi
    const largeItem = isInSeries(index, array.length)
    return {
      title: family.title,
      cover: family.coverPortrait?.[0] || family.cover?.[0],
      route: {
        name: 'product-family-slug',
        params: { slug: family.slug },
      },
      largeItem,
      // Questo listing mostra famiglie di prodotto ma ad esser filtrati sono i loro figli. Di conseguenza se non ho figli la Familgia viene comunque chimata e influisce nel pagination. Per questo non la rimuovo dall'array ma la identifico come filtrata
      // filtered: !family?.children?.length,
    }
  })
})

// Quando seleziono un filtro
const onFilterSelected = (selected) => {
  selectedCategories.value = selected
}

// Seo
useSeo({
  ...seo.value,
  meta: [
    {
      name: 'description',
      content: seo.value?.description,
    },
  ],
})
</script>
